import { useEffect } from 'react';

export const useDocumentTitle = (title) => {
    useEffect(() => {
        document.title = `${title} - Gift Shop React App`;
    }, [title]);
};
